module.exports = __webpack_public_path__ + "img/9.51c3c2f9.png";